import React, { useCallback, useState } from 'react';
import { Modal, ModalBody, ModalContent, ModalOverlay, ModalCloseButton } from '@chakra-ui/react';
import { TrustIframe } from './trust-iframe';

export function TrustModal(onlyForNewUsers = false, onSuccess) {
  const [isOpen, setIsOpen] = useState(true);

  const handleSuccess = useCallback(() => {
    onSuccess?.();
    setIsOpen(false);
  }, [onSuccess]);

  return (
    <Modal isOpen={isOpen} size="xl" onClose={() => setIsOpen(false)}>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody pt={10} paddingRight={0} paddingLeft={2}>
          <TrustIframe onSuccess={handleSuccess} onlyForNewUsers={onlyForNewUsers} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
